import Dump from './Dump.vue';
export default Dump;
